<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <v-col cols="12" sm="12" lg="12" class="pa-2 pb-0">
        <i-card-top
          class="d-flex"
          :useBtnList="buttonUseList"
          :reportItems="reportItems"
          @btnSearch="btnSearch(true)"
          @btnSave="btnSave"
          @btnDelete="btnDelete"
          @btnDownload="btnDownload"
          @btnPrint="btnPrint"
        >
          <template v-slot:body>
            <v-layout overflow-auto>
              <v-row no-gutters class="pa-2" align="center"></v-row>
            </v-layout>
          </template>
        </i-card-top>
      </v-col>
      <v-col cols="12" sm="12" lg="12" class="pa-2 pt-0">
        <i-card-vertical headerTitle="공사관리" device="web">
          <template v-slot:body>
            <v-layout column>
              <v-col cols="12" md="12" class="row pa-0">
                <v-col cols="12" lg="12" class="pa-0">
                  <DxDataGrid
                    id="constructionDataGrid"
                    class="layout-col-height00"
                    width="100%"
                    :ref="dxDataGridRef"
                    :data-source="datasource"
                    :remote-operations="false"
                    :hover-state-enabled="true"
                    :allow-column-resizing="true"
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-row-lines="true"
                    :focused-row-enabled="true"
                    @editor-preparing="onEditorPreparing"
                    key-expr="id"
                  >
                    <DxEditing
                      mode="batch"
                      :allow-updating="true"
                      :select-text-on-edit-start="true"
                    />

                    <DxSelection
                      :select-all-mode="allMode"
                      show-check-boxes-mode="always"
                      mode="multiple"
                    />

                    <DxColumn
                      data-field="consCd"
                      caption="공사코드"
                      css-class="devest-grid-header-require"
                      data-type="string"
                      alignment="left"
                    />
                  </DxDataGrid>
                </v-col>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { Workbook } from 'exceljs'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { saveAs } from 'file-saver-es'
import { exportDataGrid as exportExcel } from 'devextreme/excel_exporter'
import { exportDataGrid as exportPdf } from 'devextreme/pdf_exporter'

import { downloadFile } from '@/api/baseManage/fileUpload'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'constructionDataGrid',
  components: {},
  data() {
    return {
      dxDataGridRef: 'constructionDataGrid',
      datasource: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnSave', //저장
        'btnDelete', //삭제
        'btnDownload', //다운로드
        'btnPrint' //출력
      ],
      reportItems: [
        { role: 'pdf', title: 'PDF' },
        { role: 'xls', title: 'EXCEL' }
      ],
      allMode: 'allPages'
    }
  },
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    // 조회 버튼
    btnSearch(isNotify) {
      // this.openLoading('searching')
    },
    // 저장 버튼
    async btnSave() {},
    btnDelete() {},
    btnDownload() {},
    async btnPrint(type) {
      if (type == 'xls') {
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet('공사관리')

        exportExcel({
          component: this.GetDataGrid(this.dxDataGridRef),
          worksheet,
          autoFilterEnabled: true
        }).then(() => {
          workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), '공사관리.xlsx')
          })
        })
      }

      if (type == 'pdf') {
        const doc = new jsPDF()
        exportPdf({
          jsPDFDocument: doc,
          component: this.GetDataGrid(this.dxDataGridRef)
        }).then(() => {
          doc.save('공사관리.pdf')
        })
      }
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    //데이터 수정 시 로우 선택되도록
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    }
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
  }
}
</script>